import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import {
	server
} from '../../providers/http-service'
import util from '../../utils/util.js'
Vue.use(VueAxios, axios)
const state = {
	result: '',
	hmrts: [],
	he: {},
	hosShortName: ''
}
const actions = {
	getHbMrRecordType({
		commit
	}, params) {
		server.getHbMrRecordType(params).then(res => {
			commit('setHbMrRecordType', res)
		})
	}


}
const mutations = {
	setHbMrRecordType(state, res) {
		state.result = res.result;
		state.hmrts = res.hmrts;
		state.he = res.he;
		state.hosShortName = util.normalString(res.he.hosShortName);
	}
}
const getters = {
	items: state => {
		let hmrts =state.hmrts;
		if (hmrts.length == 1) {
			// state.show = false;
		} else {
			var hmrtsList = new Array();
			for (let i in hmrts) {
				var obj = new Object();
				obj.code = hmrts[i].code;
				obj.desc = hmrts[i].desc;
				if (hmrts[i].code == 1) {
					obj.className = "mr_item1"
				} else if (hmrts[i].code == 2) {
					obj.className = "mr_item2"
				} else if (hmrts[i].code == 3) {
					obj.className = "mr_item3"
				}
				hmrtsList.push(obj);
			}
			return hmrtsList;
		}
	}
}
export default {
	state,
	actions,
	mutations,
	getters
}
